import { graphql } from "@/lib/gql/__generated__/gql";

export const HOTEL_POLICY_UPDATE_MUTATION = graphql(/* GraphQL */ `
	mutation HotelPolicyUpdate($hotelPolicyInput: HotelPolicyInput!, $hotelDisplaySettingsInput: HotelDisplaySettingsInput!) {
		hotelPolicyUpdate(input: $hotelPolicyInput) {
			userErrors
			hotelPolicy {
				id
				checkInStart
				checkInEnd
				checkOut
				amenities
				facilities
				hotelInfo {
					title
					description
				}
				cancelPolicy {
					beforeDays
					chargeRatio
				}
				kidsPolicy {
					kidsMaxAge
					kidsDiscountType
					ratio
					static {
						currencyType
						amount
					}
				}
				kidsCosleepingPolicy {
					isActive
					kidsMaxAge
					kidsDiscountType
					ratio
					static {
						currencyType
						amount
					}
				}
				calcAdultPriceAsTotalNum
				questions {
					questionID
					required
					questionType
					question
					options
				}
				hideMailMagazineQuestion
				additionalFees {
					additionalID
					name
					price {
						currencyType
						amount
					}
					billingTypeTerm
					billingTypeTarget
					isNotDiscountTarget
					isNotTargetOnDayTrip
					isExcludeCancelFeeTarget
					useKidsPrice
					kidsPrices {
						kidsMaxAge
					}
					billingTypeTermValidation
					termValidationApplyStartDt
					termValidationApplyEndDt
				}
				isLocalPaymentAvailable
				localPaymentCancelFeeTransferLimitDays
				localPaymentCancelFeeTransferInfo {
					bankName
					branchName
					bankAccountType
					bankAccountNumber
					bankAccountHolderName
				}
				requiredPrepMillisecond
				baseReservationType
				isShowRoomPriceInCalender
				isShowPlanIncludedPrice
				isShowBestRateNotice
				isCalendarStartFromAvailableMonth
				defaultPlanID
				requiredPlanSelectForReservation
				defaultInitPeopleNum
			}
		}
		hotelDisplaySettingsUpdate(input: $hotelDisplaySettingsInput) {
			userErrors
			hotelDisplaySettings {
				id
				hotelID
				isShowCheckInOutTime
				bookedGuestSurveyDisplayStatus
			}
		}
	}
`);
